import {
  SubscriptionStatusType,
  type SubscriptionsFilterInputType,
} from "@/types/graphql/partner.generated";
import {
  isEnumValue,
  toIdList,
  toIsoDate,
} from "@/partner/shared/utils/filterValues";

/**
 * Значения фильтра из querystring в аргумент `subscriptions(filter:)`. Чистая
 * функция с проверками (см. `shared/utils/filterValues`): enum'ы сверяются со
 * сгенерированными типами, даты парсятся moment'ом, мусор молча выбрасывается.
 * Пустой результат отдаётся как `undefined`, а не `{}`.
 */
export function buildSubscriptionsFilter(
  filter: Record<string, unknown>
): SubscriptionsFilterInputType | undefined {
  const result: SubscriptionsFilterInputType = {};

  if (typeof filter.search === "string" && filter.search) {
    result.search = filter.search;
  }

  if (isEnumValue(SubscriptionStatusType, filter.status)) {
    result.status = filter.status;
  }

  const productIds = toIdList(filter.productIds);
  if (productIds) result.productIds = productIds;

  // Именно `typeof`, а не truthy-проверка: `false` это выбранный фильтр
  // «автопродление выключено», а не отсутствие фильтра. Булево значение сюда
  // приходит уже приведённым: `FilterProvider.cleanFilterValues` превращает
  // строки "true"/"false" из URL в boolean, всё остальное (например
  // ?filter[renewSubscription]=FOO) остаётся строкой и отбрасывается здесь.
  if (typeof filter.renewSubscription === "boolean") {
    result.renewSubscription = filter.renewSubscription;
  }

  const dateFrom = toIsoDate(filter.dateFrom);
  if (dateFrom) result.dateFrom = dateFrom;

  const dateTo = toIsoDate(filter.dateTo);
  if (dateTo) result.dateTo = dateTo;

  return Object.keys(result).length > 0 ? result : undefined;
}
